import { Box, Card, Container, Grid, Typography } from '@mui/material';
import useFundoPadraoHook from './useFundoPadraoHook';
import './styles.scss';

const FundoPadrao = ({ children }) => {
  const { imgLogoLogin, imgBackground } = useFundoPadraoHook();

  return (
    <Container className="container-login" style={{ backgroundImage: `url(${imgBackground})` }}>
      <Grid container>
        <Grid item xl={8} lg={8} md={7} sm={6} xs={12} className="grid-item-logo">
          <Box className="img-logo-login" style={{ backgroundImage: `url(${imgLogoLogin})` }} />
          <Box className="label-frase">
            <Box>
              <Typography variant="h5" className="texto-negrito font-size-16">
                TECNOLOGIA QUE IMPULSIONA SEU NEGÓCIO
              </Typography>
              <Typography variant="h5" className="texto-vazio" />
            </Box>
          </Box>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={6} xs={12} className="grid-item-login">
          <Card variant="outlined" className="card-login box-shadow-natural-5 border-radius-8">
            {children}
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default FundoPadrao;
